<template>
  <div class="layoutMargin">
    <div class="layoutDiv">
      <el-row :gutter="10" style="margin: 10px 15px">
        <el-col :span="8"> </el-col>
        <el-col :span="8">
          <span style="margin-left: 20px"> 数据指标： </span>
          <el-select
            v-model="dataIndex"
            placeholder="请选择"
            @change="dataIndexChange"
            size="mini"
          >
            <el-option
              v-for="item in dataIndexOptions"
              size="mini"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          <span style="margin-left: 20px"> 数据类型： </span>
          <el-select
            v-model="dataRange"
            placeholder="请选择"
            @change="dataRangeChange"
            size="mini"
          >
            <el-option
              v-for="item in dataRangeOptions"
              size="mini"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8" v-if="dataRange === 'month'">
          <span style="margin-left: 20px"> 时间： </span>
          <el-date-picker
            v-model="times"
            type="month"
            size="mini"
            value-format="yyyy-MM"
            @change="monthChange"
            :picker-options="pickerOptions"
            placeholder="选择月"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="8" v-if="dataRange === 'quarter'">
          <span>
            <quarter
              style="margin-left: 20px"
              :default-value="defaultQuarterValue"
              v-on:getQuarter="getQuarter"
            ></quarter>
          </span>
        </el-col>
        <el-col :span="8" v-if="dataRange === 'year'">
          <span style="margin-left: 20px"> 时间： </span>
          <el-date-picker
            type="year"
            v-model="year"
            size="mini"
            value-format="yyyy"
            :picker-options="pickerOptions"
            @change="yearChange"
            placeholder="选择年"
          >
          </el-date-picker>
        </el-col>
      </el-row>
      <el-row :gutter="10" style="margin: 10px 15px">
        <el-col align="center">
          全县{{
            dataIndexOptions.find((ele) => ele.value === dataIndex).label
          }}情况
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <Area v-if="showArea" :area-data="areaData" />
        </el-col>
      </el-row>
    </div>
    <el-link style="margin: 10px 15px" type="primary" @click="exportData">{{
      exportLabel
    }}</el-link>
    <div class="layoutDiv">
      `<el-row style="margin: 10px 15px">
        <el-col :span="24">
          <el-table
            v-loading="loading"
            border
            :height="tableData.length > 0 ? 420 : 180"
            size="mini"
            :header-cell-style="{ backgroundColor: '#DCDFE6', color: '#000' }"
            stripe
            :data="tableData"
          >
            <el-table-column label="行业" prop="sshy" width="150">
              <template slot-scope="scope"
                ><a
                  style="color: #5582f7; cursor: pointer"
                  @click="showDialog(scope.row)"
                  >{{ scope.row.sshy }}</a
                ></template
              >
            </el-table-column>
            <el-table-column
              prop="ljgycz"
              :formatter="handelFix2"
              sortable
              label="累计工业产值（万元）"
            >
            </el-table-column>
            <el-table-column
              prop="qntqgycz"
              :formatter="handelFix2"
              sortable
              label="去年同期工业产值（万元）"
            >
            </el-table-column>
            <el-table-column
              prop="ljgyczRate"
              :formatter="handelFix1"
              sortable
              label="工业产值累计同比增速(%)"
            >
            </el-table-column>
            <el-table-column
              prop="ljxssr"
              :formatter="handelFix2"
              sortable
              label="累计销售收入（万元）"
            >
            </el-table-column>
            <el-table-column
              prop="qntqxssr"
              :formatter="handelFix2"
              sortable
              label="去年同期销售收入（万元）"
            >
            </el-table-column>
            <el-table-column
              prop="ljxssrRate"
              :formatter="handelFix1"
              sortable
              label="销售收入累计同比增速(%)"
            >
            </el-table-column>
            <el-table-column
              prop="ljsxlr"
              :formatter="handelFix2"
              sortable
              label="累计实现利润（万元）"
            >
            </el-table-column>
            <el-table-column
              prop="qntqlr"
              :formatter="handelFix2"
              sortable
              label="去年同期利润（万元）"
            >
            </el-table-column>
            <el-table-column
              prop="ljsxlrRate"
              :formatter="handelFix1"
              sortable
              label="利润累计同比增速(%)"
            >
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <div class="pageBox">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[20, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      :title="`${areaName}`"
      :visible.sync="dialogTableVisible"
      width="90%"
      @close="closeMe"
      v-if="dialogTableVisible"
    >
      <enterprise
        :sshy-code-def="areaName"
        :data-index-def="dataIndex"
        :data-range-def="dataRange"
        :times-def="times"
      ></enterprise>
    </el-dialog>
  </div>
</template>

<script>
import Area from "@/components/Echarts/areaRotate";
import quarter from "@/components/dateUtils/quarter.vue";
import enterprise from "../enterprise";
import { export2Excel } from "@/utils/utils";
export default {
  name: "index",
  components: {
    Area,
    quarter,
    enterprise,
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      total: 0,
      loading: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      exportLabel: "<<点击此处可导出报表",
      dataIndex: "gyzjz",
      dataRange: "month",
      quarter: "",
      year: "",
      dialogTableVisible: false,
      areaName: "",
      showArea: false,
      dataIndexOptions: [
        {
          value: "gyzjz",
          label: "工业产值",
        },
        {
          value: "yysr",
          label: "销售收入",
        },
        {
          value: "lrze",
          label: "利润",
        },
      ],
      dataRangeOptions: [
        {
          value: "month",
          label: "月度",
        },
        {
          value: "quarter",
          label: "季度",
        },
        {
          value: "year",
          label: "年度",
        },
      ],
      times: "",
      defaultQuarterValue: "",
      defaultMonthValue: "",
      showTable: false,
      queryData: {
        dateType: "month",
        year: "",
        quarter: "",
        month: "",
      },
      tableData: [],
    };
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.initData();
    },
    handleCurrentChange() {
      //跳转页
      this.initData();
    },
    handelFix1(row, column) {
      if (row[column.property] && !isNaN(row[column.property])) {
        return row[column.property].toFixed(1);
      } else {
        return row[column.property];
      }
    },
    handelFix2(row, column) {
      if (row[column.property] && !isNaN(row[column.property])) {
        return row[column.property].toFixed(2);
      } else {
        return row[column.property];
      }
    },
    showDialog(row) {
      this.showArea = false;
      this.areaName = row.sshy;
      this.dialogTableVisible = true;
    },
    closeMe() {
      this.showArea = true;
      this.dialogTableVisible = false;
    },
    getNowQuarter() {
      var today = new Date();
      var month = today.getMonth() + 1; //getMonth返回0-11
      var year = today.getFullYear(); //getMonth返回0-11
      if (month < 10) {
        this.defaultMonthValue = year + "-0" + month;
        this.year = year + "-0" + month;
      } else {
        this.defaultMonthValue = year + "-" + month;
        this.year = year + month;
      }
      //下面是几个if
      if (month >= 1 && month <= 3) {
        this.quarter = "1";
        return year + "-" + "01" + "," + year + "-" + "03";
      } else if (month >= 4 && month <= 6) {
        this.quarter = "2";
        return year + "-" + "04" + "," + year + "-" + "06";
      } else if (month >= 7 && month <= 9) {
        this.quarter = "3";
        return year + "-" + "07" + "," + year + "-" + "09";
      } else if (month >= 10 && month <= 12) {
        this.quarter = "4";
        return year + "-" + "10" + "," + year + "-" + "12";
      }
    },
    dataIndexChange(value) {
      this.showTableData();
    },
    dataRangeChange(value) {
      if (value === "month") {
        this.dataTpye = "currMonth";
      } else if (value === "quarter") {
        this.getNowQuarter();
      } else {
        this.getNowQuarter();
      }
      this.initData();
    },
    monthChange() {
      this.initData();
    },
    yearChange(value) {
      this.initData();
    },
    getQuarter(value) {
      this.times = value;
      value.split(",")[0].slice(0, 4);
      this.year = value.split(",")[0].slice(0, 4);
      if (value.split(",")[0].slice(5, 7) === "01") {
        this.quarter = "1";
      } else if (value.split(",")[0].slice(5, 7) === "04") {
        this.quarter = "2";
      } else if (value.split(",")[0].slice(5, 7) === "07") {
        this.quarter = "3";
      } else if (value.split(",")[0].slice(5, 7) === "10") {
        this.quarter = "4";
      }
      this.initData();
    },
    initData() {
      const self = this;
      this.loading = true;
      if (this.dataRange === "month") {
        this.queryData.dateType = "month";
        this.queryData.month = this.times;
      } else if (this.dataRange === "quarter") {
        this.queryData.dateType = "quarter";
        this.queryData.year = this.year.slice(0, 4);
        this.queryData.quarter = this.quarter;
      } else {
        this.queryData.dateType = "year";
        this.queryData.year = this.year.slice(0, 4);
      }
      console.log("queryData:", this.queryData);
      this.$axios
        .post("/business/companyMonitor/queryBySshy", this.queryData)
        .then((res) => {
          this.srcTableData = res.data;
          this.total = res.data.length;
          self.showTableData();
          this.loading = false;
        });
    },
    showTableData() {
      const self = this;
      self.showArea = false;
      this.tableData = [];
      this.areaData = {
        xAxis: [],
        curr: {
          name: "",
          data: [],
        },
        pre: {
          name: "",
          data: [],
        },
        profit: {
          name: "",
          data: [],
        },
        unit: "万元",
      };
      this.showArea = false;
      this.srcTableData.forEach((item) => {
        if (item.sshy === "") {
          item.sshy = "其他行业";
        }
        const temp = {
          sshy: item.sshy,
          date_range: item.date_range,
          ljgycz: item.ljgycz,
          qntqgycz: item.qntqgycz,
          ljgyczRate:
            item.qntqgycz > 0
              ? ((item.ljgycz - item.qntqgycz) / item.qntqgycz) * 100
              : "--",
          ljxssr: item.ljxssr,
          qntqxssr: item.qntqxssr,
          ljxssrRate:
            item.qntqxssr > 0
              ? ((item.ljxssr - item.qntqxssr) / item.qntqxssr) * 100
              : "--",
          ljsxlr: item.ljsxlr,
          qntqlr: item.qntqlr,
          ljsxlrRate:
            item.qntqlr > 0
              ? ((item.ljsxlr - item.qntqlr) / item.qntqlr) * 100
              : "--",
        };
        if (item.sshy === "其他行业") {
          this.tableData.push(temp);
          this.areaData.xAxis.push(item.sshy);
          this.areaData.curr.name = "累计";
          this.areaData.pre.name = "上年同期";
          this.areaData.profit.name = "同比增速";
          if (this.dataIndex === "gyzjz") {
            // 工业增加值
            this.areaData.curr.data.push(temp.ljgycz);
            this.areaData.pre.data.push(temp.qntqgycz);
            this.areaData.profit.data.push(temp.ljgyczRate);
          } else if (this.dataIndex === "yysr") {
            // 营业收入
            this.areaData.curr.data.push(temp.ljxssr);
            this.areaData.pre.data.push(temp.qntqxssr);
            this.areaData.profit.data.push(temp.ljxssrRate);
          } else if (this.dataIndex === "lrze") {
            // 利润总额
            this.areaData.curr.data.push(temp.ljsxlr);
            this.areaData.pre.data.push(temp.qntqlr);
            this.areaData.profit.data.push(temp.ljsxlrRate);
          }
        } else {
          this.tableData.push(temp);
          this.areaData.xAxis.push(item.sshy);
          this.areaData.curr.name = "累计";
          this.areaData.pre.name = "上年同期";
          this.areaData.profit.name = "同比增速";
          if (this.dataIndex === "gyzjz") {
            // 工业增加值
            this.areaData.curr.data.push(temp.ljgycz);
            this.areaData.pre.data.push(temp.qntqgycz);
            this.areaData.profit.data.push(temp.ljgyczRate);
          } else if (this.dataIndex === "yysr") {
            // 营业收入
            this.areaData.curr.data.push(temp.ljxssr);
            this.areaData.pre.data.push(temp.qntqxssr);
            this.areaData.profit.data.push(temp.ljxssrRate);
          } else if (this.dataIndex === "lrze") {
            // 利润总额
            this.areaData.curr.data.push(temp.ljsxlr);
            this.areaData.pre.data.push(temp.qntqlr);
            this.areaData.profit.data.push(temp.ljsxlrRate);
          }
        }
      });
      console.log(">>>>>>>>>>>>>>", this.srcTableData);
      console.log(">>>>>>>>>>>>>>", this.tableData);
      setTimeout(function () {
        self.showArea = true;
      }, 5);
    },
    exportData() {
      let column = [
        {
          title: "行业",
          key: "sshy",
        },
        {
          title: "累计工业产值（万元）",
          toFixed: 2,
          key: "ljgycz",
        },
        {
          title: "去年同期工业产值（万元）",
          toFixed: 2,
          key: "qntqgycz",
        },
        {
          title: "工业产值累计同比增速(%)",
          toFixed: 1,
          key: "ljgyczRate",
        },
        {
          title: "累计销售收入（万元）",
          toFixed: 2,
          key: "ljxssr",
        },
        {
          title: "去年同期销售收入（万元）",
          toFixed: 2,
          key: "qntqxssr",
        },
        {
          title: "销售收入累计同比增速(%)",
          toFixed: 1,
          key: "ljxssrRate",
        },
        {
          title: "累计实现利润（万元）",
          toFixed: 2,
          key: "ljsxlr",
        },
        {
          title: "累计实现利润（万元）",
          toFixed: 2,
          key: "qntqlr",
        },
        {
          title: "利润累计同比增速(%)",
          toFixed: 1,
          key: "ljsxlrRate",
        },
      ];
      let timeStr = "";
      if (this.dataRange === "year") {
        timeStr = this.times.slice(0, 4) + "年";
      } else if (this.dataRange === "quarter") {
        const temp = parseInt(this.times.slice(5, 7));
        let quarter = "";
        if (temp < 4) {
          quarter = "1";
        } else if (temp < 7) {
          quarter = "2";
        } else if (temp < 10) {
          quarter = "3";
        } else if (temp < 13) {
          quarter = "4";
        }
        timeStr = this.times.slice(0, 4) + "年第" + quarter + "季度";
      } else {
        timeStr = this.times.slice(0, 4) + "年" + this.times.slice(5, 7) + "月";
      }
      export2Excel(
        column,
        this.tableData,
        this.dataIndexOptions.find((ele) => ele.value === this.dataIndex)
          .label +
          "_" +
          timeStr
      );
    },
  },
  created() {
    this.defaultQuarterValue = this.getNowQuarter();
    this.times = this.defaultMonthValue;
    console.log("aaaaaaaaaaaaaaaaaaaaaaaaa");
    this.initData();
  },
};
</script>

<style scoped>
</style>